module.exports = __webpack_public_path__ + "img/banner.5f6dfb15.png";